import * as React from 'react';
import CTSAReportHeader from "./CTSAReportHeader";
import CompareGroupSelector from "./CompareGroupSelector";
import { transformTotals } from "./CTSAReportHelper";
import AwardChart from "./AwardChart";



interface Props {
    comparisonGroup?: string[];
    availableGroup?: string[];
    changeComparisonGroup?();
    displayId?: string;
    CTSASchoolList?: {}[];
    awardData?: {}[];
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number }

}


class R01Attainment extends React.Component<Props, {}> {



    render() {
        const { awardTotal, awardData, comparisonGroup, availableGroup, displayId, CTSASchoolList, changeComparisonGroup } = this.props;

        if (awardTotal && awardData && comparisonGroup && availableGroup) {
            return (
                <div className="tabcontents container-fluid" style={{ border: 'none' }}>

                    <CTSAReportHeader compareGroup={comparisonGroup} displayId={displayId} CTSASchoolList={CTSASchoolList} awardTotal={transformTotals(awardTotal)} />
                    <CompareGroupSelector
                        onChange={changeComparisonGroup}
                        selectedGroup={comparisonGroup}
                        awardTotal={transformTotals(awardTotal)}
                        availableGroup={availableGroup}
                    />
                    <AwardChart compareGroup={comparisonGroup} awardTotal={transformTotals(awardTotal)} awardData={awardData} />                  
                    <img src={require('./CTSA_logo.jpg')} height='50px' style={{ marginTop: '20px' }} />
                </div>


            );
        } else {
            return <i className="fa fa-spinner"></i>;
        }

    }
}
export default R01Attainment;




